import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		list: [],
		downloadLink: null,
		isLoadLink: false,
		isLoadDownloadLoadLink: false
	},
	actions: {
		async fetch({ commit }) {
			var response = await Vue.http.get('templates/')
			commit('setList', response.body)
		},

		async saveTemplate({ rootState }, query) {
			let id = rootState.route.params.templateId
			let config = JSON.parse(query.template)
			await Vue.http.post('templates/' + id, {
				config: config,
				template_name: query.template_name
			})
		},

		async downloadPreview({ commit, rootState }) {
			try {
				commit('setIsLoadDownloadLink', true)
				let id = rootState.route.params.templateId
				let response = await Vue.http.post('templates/' + id + '/preview')
				commit(
					'setLink',
					Vue.http.options.root + '/files/docs/' + response.body.outputFilename
				)
				commit('setIsLoadDownloadLink', false)
				return response
			} catch (e) {
				commit('setIsLoadDownloadLink', false)
			}
		},

		async render({ commit, rootState }, query) {
			try {
				commit('setIsLoad', true)
				let workerId = rootState.route.params.workerId
				let link = 'templates/' + query.tempalteId + '/render/' + workerId
				console.log(link)
				let response = await Vue.http.post(link, {
					userId: query.user_id ? query.user_id : null
				})
				commit('setIsLoad', false)
				commit(
					'setLink',
					Vue.http.options.root + '/files/docs/' + response.body.outputFilename
				)
			} catch (e) {
				commit('setIsLoad', false)
				//TODO add error handling
				console.error(e)
			}
		},

		async deleteTemplate({ dispatch }, deleteId) {
			let response = await Vue.http.delete('templates/' + deleteId)
			console.log(response.body)
			// call fetch
			dispatch('fetch')
		},
		clearLink({ commit }) {
			commit('setLink', null)
		}
	},
	mutations: {
		setList(state, list) {
			state.list = [...list]
		},
		setLink(state, link) {
			state.downloadLink = link
		},
		setIsLoad(state, status) {
			state.isLoadLink = status
		},
		setIsLoadDownloadLink(state, status) {
			state.isLoadDownloadLoadLink = status
		}
	}
}
